"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CLASS_STATUSES", {
  enumerable: true,
  get: function get() {
    return _constants.CLASS_STATUSES;
  }
});
Object.defineProperty(exports, "EYES_UP_STATUSES", {
  enumerable: true,
  get: function get() {
    return _constants.EYES_UP_STATUSES;
  }
});
Object.defineProperty(exports, "PRESENCE_ACTIONS", {
  enumerable: true,
  get: function get() {
    return _constants.PRESENCE_ACTIONS;
  }
});
Object.defineProperty(exports, "ROLES", {
  enumerable: true,
  get: function get() {
    return _constants.ROLES;
  }
});
Object.defineProperty(exports, "STUDENT_LOCATION_STATUSES", {
  enumerable: true,
  get: function get() {
    return _constants.STUDENT_LOCATION_STATUSES;
  }
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _realtimeService = _interopRequireDefault(require("./services/realtimeService"));

var _classroomOrchestrationService = _interopRequireDefault(require("./services/classroomOrchestrationService"));

var _autosaveNotificationService = _interopRequireDefault(require("./services/autosaveNotificationService"));

var _submissionNotificationService = _interopRequireDefault(require("./services/submissionNotificationService"));

var _userStorageNotificationService = _interopRequireDefault(require("./services/userStorageNotificationService"));

var _sharedDataService = _interopRequireDefault(require("./services/sharedDataService"));

var _xApiEventService = _interopRequireDefault(require("./services/xApiEventService"));

var _classStateService = _interopRequireDefault(require("./services/classStateService"));

var _monitoringService = _interopRequireDefault(require("./services/monitoringService"));

var _logger = _interopRequireDefault(require("./utils/logger"));

var _constants = require("./shared/constants");

/**
 * @fileoverview Main interface for amp-realtime. Provides:
 * - Generic methods for publishing realtime messages, subscribing to message channels, and registering message event
 *   handlers.
 * - Methods for publishing messages and registering event handlers for functionality specific to classroom
 *   orchestration, such as class status, class eyes-up status, and class content location.
 * - Methods for publishing messages and registering event handlers for student autosave, user storage service
 *   and submission events.
 */

/** Interface for the AmpRealtime library */
var AmpRealtime = /*#__PURE__*/function () {
  function AmpRealtime(ampConfig, userId) {
    var configOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    (0, _classCallCheck2.default)(this, AmpRealtime);
    (0, _defineProperty2.default)(this, "classStateService", void 0);
    var filterConfig = configOptions.filterConfig,
        ampEventsInstance = configOptions.ampEventsInstance,
        connectionChangeCallback = configOptions.connectionChangeCallback,
        datadogRum = configOptions.datadogRum;

    _realtimeService.default.init(ampConfig, userId, filterConfig, connectionChangeCallback);

    _classroomOrchestrationService.default.init(userId);

    _sharedDataService.default.init(userId);

    if (datadogRum) {
      _monitoringService.default.setDatadogRum(datadogRum);
    }

    this.classStateService = _classStateService.default;
    this.classStateService.userId = userId;

    try {
      _xApiEventService.default.init(ampEventsInstance, userId);
    } catch (error) {
      _logger.default.warn('Error initializing realtime event capture', error);
    }
  }
  /**
   * Publish a message to a channel.
   */


  (0, _createClass2.default)(AmpRealtime, [{
    key: "publish",
    value: function publish(channelName, eventType, payload) {
      var recipient = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _constants.ROLES.ALL;
      return _realtimeService.default.publish(channelName, eventType, payload, recipient);
    }
    /**
     * Add a message listener for a given event type.
     */

  }, {
    key: "addEventListener",
    value: function addEventListener(eventType, callback) {
      _realtimeService.default.addEventListener(eventType, callback);
    }
    /**
     * Remove a message listener.
     */

  }, {
    key: "removeEventListener",
    value: function removeEventListener(eventType, callback) {
      _realtimeService.default.removeEventListener(eventType, callback);
    }
    /**
     * Removes all event listeners that are registered to a given event type.
     */

  }, {
    key: "removeListenersForType",
    value: function removeListenersForType(eventType) {
      _realtimeService.default.removeListenersForType(eventType);
    }
    /**
     * Remove all message listeners.
     */

  }, {
    key: "removeAllEventListeners",
    value: function removeAllEventListeners() {
      _realtimeService.default.removeAllEventListeners();
    }
    /**
     * Destroy all realtime connections.
     */

  }, {
    key: "destroy",
    value: function destroy() {
      _realtimeService.default.destroy();
    }
    /**
     * Add a listener for presence events on a particular channel.
     */

  }, {
    key: "addPresenceListener",
    value: function addPresenceListener(channelName, callback) {
      _realtimeService.default.addPresenceListener(channelName, callback);
    }
    /**
     * Remove listener for presence events.
     */

  }, {
    key: "removePresenceListener",
    value: function removePresenceListener(channelName, callback) {
      _realtimeService.default.removePresenceListener(channelName, callback);
    }
    /**
     * Get the ids of current subscribers to a given channel.
     */

  }, {
    key: "getCurrentSubscribers",
    value: function getCurrentSubscribers(channelName) {
      return _realtimeService.default.getCurrentSubscribers(channelName);
    }
    /**
     * Subscribe to one or more channels, with or without subscribing to presence.
     */

  }, {
    key: "subscribeToChannels",
    value: function subscribeToChannels(channelNames, withPresence) {
      _realtimeService.default.subscribeToChannels(channelNames, withPresence);
    }
    /**
     * Unsubscribe from one or more channels.
     */

  }, {
    key: "unsubscribeFromChannels",
    value: function unsubscribeFromChannels(channelNames) {
      _realtimeService.default.unsubscribeFromChannels(channelNames);
    }
    /**
     * Unsubscribe from all channels.
     */

  }, {
    key: "unsubscribeFromAll",
    value: function unsubscribeFromAll() {
      _realtimeService.default.unsubscribeFromAll();
    }
    /**
     * Publish status (started or not started) for a class. Updates the persisted class status record.
     */

  }, {
    key: "publishClassStatus",
    value: function publishClassStatus(classBusinessKey, isStarted) {
      var recipient = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.ROLES.ALL;

      var _classStateService$ge = _classStateService.default.getClassData(classBusinessKey),
          managingTabId = _classStateService$ge.managingTabId,
          classSessionId = _classStateService$ge.classSessionId;

      return _classroomOrchestrationService.default.publishClassStatus(classBusinessKey, isStarted, managingTabId, classSessionId, recipient);
    }
    /**
     * Publish eyes-up status (active or inactive) for a class. Updates the persisted class eyes-up status record.
     */

  }, {
    key: "publishClassEyesUpStatus",
    value: function publishClassEyesUpStatus(classBusinessKey, isEyesUpActive) {
      var recipient = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.ROLES.ALL;
      return _classroomOrchestrationService.default.publishClassEyesUpStatus(classBusinessKey, isEyesUpActive, recipient);
    }
    /**
     * Publish content location (breadcrumb) for a classroom. Updates the persisted class content location record.
     */

  }, {
    key: "publishClassContentLocation",
    value: function publishClassContentLocation(classBusinessKey, contentBreadcrumb) {
      var recipient = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.ROLES.ALL;
      return _classroomOrchestrationService.default.publishClassContentLocation(classBusinessKey, contentBreadcrumb, recipient);
    }
    /**
     * Publish class pacing for a class. Updates the persisted class pacing record.
     */

  }, {
    key: "publishClassPacing",
    value: function publishClassPacing(classBusinessKey, classPacing) {
      var recipient = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.ROLES.ALL;
      return _classroomOrchestrationService.default.publishClassPacing(classBusinessKey, classPacing, recipient);
    }
    /**
     * Publish content location (breadcrumb) for the current student. Updates the persisted student content location
     * record.
     */

  }, {
    key: "publishStudentLocation",
    value: function publishStudentLocation(classBusinessKey, contentBreadcrumb, status) {
      var recipient = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _constants.ROLES.ALL;
      return _classroomOrchestrationService.default.publishStudentLocation(classBusinessKey, contentBreadcrumb, status, recipient);
    }
    /**
     * Publish hand raise state for the current student. Updates the persisted student hand raise state record.
     */

  }, {
    key: "publishStudentHandRaiseState",
    value: function publishStudentHandRaiseState(classBusinessKey, studentId, raised, classSessionId, recipient) {
      return _classroomOrchestrationService.default.publishStudentHandRaiseState(classBusinessKey, studentId, raised, classSessionId, recipient);
    }
    /**
     * Publish data of a certain record type for a classroom. Updates the persisted record data for this type.
     */

  }, {
    key: "publishClassRecord",
    value: function publishClassRecord(classBusinessKey, recordType, record) {
      var recipient = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _constants.ROLES.ALL;
      return _classroomOrchestrationService.default.publishClassRecord(classBusinessKey, recordType, record, recipient);
    }
    /**
     * Publish data of a certain record type for a student. Updates the persisted record data for this type.
     */

  }, {
    key: "publishStudentRecord",
    value: function publishStudentRecord(studentId, classBusinessKey, recordType, record) {
      var recipient = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _constants.ROLES.ALL;
      return _classroomOrchestrationService.default.publishStudentRecord(studentId, classBusinessKey, recordType, record, recipient);
    }
  }, {
    key: "publishStudentVariantChangeNotification",
    value: function publishStudentVariantChangeNotification(classKey, studentIds) {
      var recipient = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.ROLES.ALL;
      return _classroomOrchestrationService.default.publishStudentVariantChange(classKey, studentIds, recipient);
    }
  }, {
    key: "addListenerForStudentVariantChange",
    value: function addListenerForStudentVariantChange(classKeys, studentIds, variantDisplaySchema, callback) {
      _classroomOrchestrationService.default.addListenerForStudentVariantChange(classKeys, studentIds, variantDisplaySchema, callback);
    }
  }, {
    key: "removeListenerForStudentVariantChange",
    value: function removeListenerForStudentVariantChange(callback) {
      _classroomOrchestrationService.default.removeListenerForStudentVariantChange(callback);
    }
    /**
     * Add an event listener for class status updates. Callbacks are immediately triggered with the current persisted
     * class status data for each class.
     */

  }, {
    key: "addListenerForClassStatus",
    value: function addListenerForClassStatus(classBusinessKeys, callback) {
      _classroomOrchestrationService.default.addListenerForClassStatus(classBusinessKeys, callback);
    }
    /**
     * Add an event listener for class eyes-up status updates. Callbacks are immediately triggered with the current
     * persisted eyes-up status data for each class.
     */

  }, {
    key: "addListenerForEyesUpStatus",
    value: function addListenerForEyesUpStatus(classBusinessKeys, callback) {
      _classroomOrchestrationService.default.addListenerForEyesUpStatus(classBusinessKeys, callback);
    }
    /**
     * Add an event listener for class content location updates. Callbacks are immediately triggered with the current
     * persisted class content location data for each class.
     */

  }, {
    key: "addListenerForClassContentLocation",
    value: function addListenerForClassContentLocation(classBusinessKeys, callback) {
      _classroomOrchestrationService.default.addListenerForClassContentLocation(classBusinessKeys, callback);
    }
    /**
     * Add an event listener for student content location updates. Callbacks are immediately triggered with the current
     * persisted content location data for each student.
     */

  }, {
    key: "addListenerForStudentLocations",
    value: function addListenerForStudentLocations(classBusinessKey, studentIds, callback) {
      _classroomOrchestrationService.default.addListenerForStudentLocations(classBusinessKey, studentIds, callback);
    }
    /**
     * Add an event listener for student hand raise state updates. Callbacks are immediately triggered with the current
     * persisted content location data for each student.
     */

  }, {
    key: "addListenerForStudentHandRaiseState",
    value: function addListenerForStudentHandRaiseState(classBusinessKey, studentIds, callback) {
      _classroomOrchestrationService.default.addListenerForStudentHandRaiseState(classBusinessKey, studentIds, callback);
    }
    /**
     * Add an event listener for class pacing updates. Callbacks are immediately triggered with the current
     * persisted class pacing data for each student.
     */

  }, {
    key: "addListenerForClassPacing",
    value: function addListenerForClassPacing(classBusinessKeys, callback) {
      _classroomOrchestrationService.default.addListenerForClassPacing(classBusinessKeys, callback);
    }
    /**
     * Add an event listener for changes to records of a certain record type for a classroom. Callbacks are immediately
     * triggered with the current persisted record data for this type for each class.
     */

  }, {
    key: "addListenerForClassRecord",
    value: function addListenerForClassRecord(classBusinessKeys, recordType, callback) {
      _classroomOrchestrationService.default.addListenerForClassRecord(classBusinessKeys, recordType, callback);
    }
    /**
     * Add an event listener for changes to records of a certain record type for a student. Callbacks are immediately
     * triggered with the current persisted record data for this type for each student.
     */

  }, {
    key: "addListenerForStudentRecord",
    value: function addListenerForStudentRecord(classKey, studentIds, recordType, callback) {
      _classroomOrchestrationService.default.addListenerForStudentRecord(classKey, studentIds, recordType, callback);
    }
    /**
     * Remove an event listener for class status updates.
     */

  }, {
    key: "removeListenerForClassStatus",
    value: function removeListenerForClassStatus(callback) {
      _classroomOrchestrationService.default.removeListenerForClassStatus(callback);
    }
    /**
     * Remove an event listener for class eyes-up status updates.
     */

  }, {
    key: "removeListenerForEyesUpStatus",
    value: function removeListenerForEyesUpStatus(callback) {
      _classroomOrchestrationService.default.removeListenerForEyesUpStatus(callback);
    }
    /**
     * Remove an event listener for class content location updates.
     */

  }, {
    key: "removeListenerForClassContentLocation",
    value: function removeListenerForClassContentLocation(callback) {
      _classroomOrchestrationService.default.removeListenerForClassContentLocation(callback);
    }
    /**
     * Remove an event listener for student content location updates.
     */

  }, {
    key: "removeListenerForStudentLocations",
    value: function removeListenerForStudentLocations(callback) {
      _classroomOrchestrationService.default.removeListenerForStudentLocations(callback);
    }
    /**
     * Remove an event listener for student hand raise updates.
     */

  }, {
    key: "removeListenerForStudentHandRaiseState",
    value: function removeListenerForStudentHandRaiseState(callback) {
      _classroomOrchestrationService.default.removeListenerForStudentHandRaiseState(callback);
    }
    /**
     * Remove an event listener for student class pacing updates.
     */

  }, {
    key: "removeListenerForClassPacing",
    value: function removeListenerForClassPacing(callback) {
      _classroomOrchestrationService.default.removeListenerForClassPacing(callback);
    }
    /**
     * Publish a notification that an autosave record was updated. Should be triggered from the student side
     * after an autosave update POST has completed.
     */

  }, {
    key: "publishAutosaveNotification",
    value: function publishAutosaveNotification(classBusinessKey, cardstackBusinessKey) {
      var recipient = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.ROLES.ALL;
      return _autosaveNotificationService.default.publishNotification(classBusinessKey, cardstackBusinessKey, recipient);
    }
    /**
     * Register a callback to listen for autosave updates for a set of users and cardstacks in a given class. Listener
     * will be called with the full set of current autosaves initially and then every time an autosave update
     * notification is updated.
     *
     * Note, autosave updates are batched together.
     *
     * The payload passed to the callback is an array of cardstack autosave objects with an entry for every
     * user/cardstack combination.
     */

  }, {
    key: "addListenerForAutosaves",
    value: function addListenerForAutosaves(classBusinessKey, userIds, cardstackBusinessKeys, callback) {
      _autosaveNotificationService.default.addListener(classBusinessKey, userIds, cardstackBusinessKeys, callback);
    }
    /**
     * Remove an event listener for autosave updates.
     */

  }, {
    key: "removeListenerForAutosaves",
    value: function removeListenerForAutosaves(callback) {
      _autosaveNotificationService.default.removeListener(callback);
    }
    /**
     * Publish a notification that a user storage service record was updated.
     * Should be triggered from the student side after a user storage update POST has completed.
     */

  }, {
    key: "publishUserStorageNotification",
    value: function publishUserStorageNotification(classBusinessKey, storagePrefix, fileKeys) {
      var recipient = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _constants.ROLES.ALL;
      return _userStorageNotificationService.default.publishNotification(classBusinessKey, storagePrefix, fileKeys, recipient);
    }
    /**
     * Register a callback to listen for user storage service updates for a set of users and storage prefixes in a given
     * class. Listener will be called with the full set of current storage data initially and then every time a storage
     * update notification is updated.
     *
     * Note, user storage updates are batched together.
     *
     * The payload passed to the callback is an array of objects with an entry for every user/storagePrefix/fileKey
     * combination.
     */

  }, {
    key: "addListenerForUserStorage",
    value: function addListenerForUserStorage(classBusinessKey, userIds, storagePrefixes, callback) {
      _userStorageNotificationService.default.addListener(classBusinessKey, userIds, storagePrefixes, callback);
    }
    /**
     * Remove an event listener for user storage service updates.
     */

  }, {
    key: "removeListenerForUserStorage",
    value: function removeListenerForUserStorage(callback) {
      _userStorageNotificationService.default.removeListener(callback);
    }
    /**
     * Publish a notification that a cardstack response was submitted (handed in).
     * Should be triggered from the student side after a submission POST has completed.
     */

  }, {
    key: "publishSubmissionNotification",
    value: function publishSubmissionNotification(classBusinessKey, cardstackBusinessKey) {
      var recipient = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.ROLES.ALL;
      return _submissionNotificationService.default.publishNotification(classBusinessKey, cardstackBusinessKey, recipient);
    }
    /**
     * Register a callback to listen for submissions for a set of users and cardstacks in an active class. Listener will
     * be called with the full set of current submissions initially and then for every submission that is updated.
     *
     * The payload passed to the callback is an array of activity submission objects with an entry for every
     * user/activity combination.
     */

  }, {
    key: "addListenerForSubmissions",
    value: function addListenerForSubmissions(classBusinessKey, userIds, cardstackBusinessKeys, callback, appName) {
      _submissionNotificationService.default.addListener(classBusinessKey, userIds, cardstackBusinessKeys, callback, appName);
    }
    /**
     * Remove an event listener for submission updates.
     */

  }, {
    key: "removeListenerForSubmissions",
    value: function removeListenerForSubmissions(callback) {
      _submissionNotificationService.default.removeListener(callback);
    }
    /**
     * Store data to shared storage and publish a realtime notification.
     */

  }, {
    key: "publishSharedStudentData",
    value: function publishSharedStudentData(classBusinessKey, fileKey, data) {
      return _sharedDataService.default.publish(classBusinessKey, fileKey, data);
    }
    /**
     * Register a callback to listen for shared student data updates within a class for a file prefix.
     * Listener will be called with the full set of shared data for the class initially and then for every update.
     */

  }, {
    key: "addListenerForSharedStudentData",
    value: function addListenerForSharedStudentData(classBusinessKey, prefix, callback) {
      _sharedDataService.default.addListener(classBusinessKey, prefix, callback);
    }
    /**
     * Remove an event listener for shared student data updates.
     */

  }, {
    key: "removeListenerForSharedStudentData",
    value: function removeListenerForSharedStudentData(callback) {
      _sharedDataService.default.removeListener(callback);
    }
    /**
     * Set context extensions to include with emitted xAPI events.
     */

  }, {
    key: "setEventContextExtensions",
    value: function setEventContextExtensions(contextExtensions) {
      _xApiEventService.default.setContextExtensions(contextExtensions);
    }
    /**
     * Set result extensions to include with emitted xAPI events.
     */

  }, {
    key: "setEventResultExtensions",
    value: function setEventResultExtensions(resultExtensions) {
      _xApiEventService.default.setResultExtensions(resultExtensions);
    }
    /**
     * Included only to support legacy code from the curriculum app.
     * @deprecated
     */

    /* eslint-disable @typescript-eslint/no-explicit-any */

  }, {
    key: "subscribeAndListen",
    value: function subscribeAndListen(channels, listenerObj, withPresence) {
      _logger.default.warn('subscribeAndListen method is deprecated!');

      _realtimeService.default.subscribeAndListen(channels, listenerObj, withPresence);
    }
    /**
     * Included only to support legacy code from the curriculum app.
     * @deprecated
     */

    /* eslint-disable @typescript-eslint/no-explicit-any */

  }, {
    key: "stopListeningAndUnsubscribe",
    value: function stopListeningAndUnsubscribe(channels, listenerObj) {
      _logger.default.warn('stopListeningAndUnsubscribe method is deprecated!');

      _realtimeService.default.stopListeningAndUnsubscribe(channels, listenerObj);
    }
  }]);
  return AmpRealtime;
}();

var _default = AmpRealtime;
exports.default = _default;
//# sourceMappingURL=index.js.map